import {NgModule} from "@angular/core";
import {BrowserModule} from "@angular/platform-browser";
import {PropertyContainerComponent} from "./property-container.component";
import {PropertyItemComponent} from "./property-item.component";

@NgModule({
  imports: [
    BrowserModule,
  ],
  declarations: [
    PropertyContainerComponent,
    PropertyItemComponent,
  ],
  exports: [
    PropertyContainerComponent,
    PropertyItemComponent,
  ],
})
export class PropertyContainerModule {}
